// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  color: white;
  transition: width 0.3s ease;
  z-index: 1000;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  overflow-x: hidden;
}

.sidebar.sidebar-open {
  width: 280px;
}

.sidebar.sidebar-closed {
  width: 70px;
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.logo-icon {
  font-size: 1.5rem;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  padding: 0.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-text {
  font-size: 1.25rem;
  font-weight: 700;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.sidebar-toggle {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  padding: 0.5rem;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 1rem;
}

.sidebar-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
}

.sidebar-nav {
  flex: 1 1;
  padding: 1rem 0;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  margin: 0.25rem 0;
}

.nav-section {
  padding: 0.75rem 1rem;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

/* Group & submenu */
.nav-group .nav-group-toggle {
  width: 100%;
  text-align: left;
  background: transparent;
  border: 0;
  cursor: pointer;
  font: inherit;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.nav-caret {
  margin-left: auto;
  transition: transform 0.2s ease;
}

.nav-caret.rotated {
  transform: rotate(90deg);
}

.sub-list {
  list-style: none;
  margin: 0;
  padding: 0 0 0 0.5rem;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.25s ease;
}

.sub-list.open {
  max-height: 500px; /* suffisamment grand pour le contenu */
}

.nav-sublink {
  padding-left: 2.5rem;
  background: rgba(255, 255, 255, 0.04);
}

.nav-sublink:hover {
  background: rgba(255, 255, 255, 0.12);
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.2s;
  border-radius: 0;
  position: relative;
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.nav-link.active {
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.nav-link.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: white;
}

.nav-icon {
  font-size: 1.25rem;
  min-width: 1.5rem;
  text-align: center;
}

.nav-label {
  font-weight: 500;
  white-space: nowrap;
}

.sidebar-footer {
  padding: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 0.5rem;
  transition: background-color 0.2s;
}

.user-info:hover {
  background: rgba(255, 255, 255, 0.1);
}

.user-avatar {
  width: 2.5rem;
  height: 2.5rem;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
}

.user-details {
  flex: 1 1;
}

.user-name {
  font-weight: 600;
  font-size: 0.875rem;
  color: white;
}

.user-role {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.6);
}

/* Responsive */
@media (max-width: 768px) {
  .sidebar-open {
    width: 100%;
  }
  
  .sidebar-closed {
    width: 0;
    overflow: hidden;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qDAAqD;EACrD,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;EACb,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB,EAAE,uCAAuC;AAC5D;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;AACF","sourcesContent":[".sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);\n  color: white;\n  transition: width 0.3s ease;\n  z-index: 1000;\n  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n  overflow-x: hidden;\n}\n\n.sidebar.sidebar-open {\n  width: 280px;\n}\n\n.sidebar.sidebar-closed {\n  width: 70px;\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.5rem 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.sidebar-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.logo-icon {\n  font-size: 1.5rem;\n  background: linear-gradient(135deg, #3b82f6, #8b5cf6);\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.logo-text {\n  font-size: 1.25rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #3b82f6, #8b5cf6);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.sidebar-toggle {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: white;\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-size: 1rem;\n}\n\n.sidebar-toggle:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.sidebar-nav {\n  flex: 1;\n  padding: 1rem 0;\n}\n\n.nav-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.nav-item {\n  margin: 0.25rem 0;\n}\n\n.nav-section {\n  padding: 0.75rem 1rem;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 0.75rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n/* Group & submenu */\n.nav-group .nav-group-toggle {\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  font: inherit;\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n.nav-caret {\n  margin-left: auto;\n  transition: transform 0.2s ease;\n}\n\n.nav-caret.rotated {\n  transform: rotate(90deg);\n}\n\n.sub-list {\n  list-style: none;\n  margin: 0;\n  padding: 0 0 0 0.5rem;\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.25s ease;\n}\n\n.sub-list.open {\n  max-height: 500px; /* suffisamment grand pour le contenu */\n}\n\n.nav-sublink {\n  padding-left: 2.5rem;\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.nav-sublink:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  transition: all 0.2s;\n  border-radius: 0;\n  position: relative;\n}\n\n.nav-link:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.nav-link.active {\n  background: linear-gradient(135deg, #3b82f6, #8b5cf6);\n  color: white;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.nav-link.active::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: white;\n}\n\n.nav-icon {\n  font-size: 1.25rem;\n  min-width: 1.5rem;\n  text-align: center;\n}\n\n.nav-label {\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.sidebar-footer {\n  padding: 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 0.5rem;\n  transition: background-color 0.2s;\n}\n\n.user-info:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.user-avatar {\n  width: 2.5rem;\n  height: 2.5rem;\n  background: linear-gradient(135deg, #3b82f6, #8b5cf6);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n}\n\n.user-details {\n  flex: 1;\n}\n\n.user-name {\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: white;\n}\n\n.user-role {\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .sidebar-open {\n    width: 100%;\n  }\n  \n  .sidebar-closed {\n    width: 0;\n    overflow: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
